'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var ndjson = require('iterable-ndjson');

var CID = require('cids');

var configure = require('../lib/configure');

var toIterable = require('stream-to-it/source');

var _require = require('./form-data'),
    toFormData = _require.toFormData;

var toCamel = require('../lib/object-to-camel');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _add = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, file;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);
              searchParams.set('stream-channels', true);
              if (options.chunker) searchParams.set('chunker', options.chunker);
              if (options.cidVersion) searchParams.set('cid-version', options.cidVersion);
              if (options.cidBase) searchParams.set('cid-base', options.cidBase);
              if (options.enableShardingExperiment != null) searchParams.set('enable-sharding-experiment', options.enableShardingExperiment);
              if (options.hashAlg) searchParams.set('hash', options.hashAlg);
              if (options.onlyHash != null) searchParams.set('only-hash', options.onlyHash);
              if (options.pin != null) searchParams.set('pin', options.pin);
              if (options.progress) searchParams.set('progress', true);
              if (options.quiet != null) searchParams.set('quiet', options.quiet);
              if (options.quieter != null) searchParams.set('quieter', options.quieter);
              if (options.rawLeaves != null) searchParams.set('raw-leaves', options.rawLeaves);
              if (options.shardSplitThreshold) searchParams.set('shard-split-threshold', options.shardSplitThreshold);
              if (options.silent) searchParams.set('silent', options.silent);
              if (options.trickle != null) searchParams.set('trickle', options.trickle);
              if (options.wrapWithDirectory != null) searchParams.set('wrap-with-directory', options.wrapWithDirectory);
              if (options.preload != null) searchParams.set('preload', options.preload);
              if (options.fileImportConcurrency != null) searchParams.set('file-import-concurrency', options.fileImportConcurrency);
              if (options.blockWriteConcurrency != null) searchParams.set('block-write-concurrency', options.blockWriteConcurrency);
              _context.t0 = _awaitAsyncGenerator;
              _context.t1 = ky;
              _context.t2 = options.timeout;
              _context.t3 = options.signal;
              _context.t4 = options.headers;
              _context.t5 = searchParams;
              _context.next = 29;
              return _awaitAsyncGenerator(toFormData(input));

            case 29:
              _context.t6 = _context.sent;
              _context.t7 = {
                timeout: _context.t2,
                signal: _context.t3,
                headers: _context.t4,
                searchParams: _context.t5,
                body: _context.t6
              };
              _context.t8 = _context.t1.post.call(_context.t1, 'add', _context.t7);
              _context.next = 34;
              return (0, _context.t0)(_context.t8);

            case 34:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 37;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 39:
              _context.next = 41;
              return _awaitAsyncGenerator(_iterator.next());

            case 41:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 45;
              return _awaitAsyncGenerator(_step.value);

            case 45:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 58;
                break;
              }

              file = _value;
              file = toCamel(file);

              if (!(options.progress && file.bytes)) {
                _context.next = 53;
                break;
              }

              options.progress(file.bytes);
              _context.next = 55;
              break;

            case 53:
              _context.next = 55;
              return toCoreInterface(file);

            case 55:
              _iteratorNormalCompletion = true;
              _context.next = 39;
              break;

            case 58:
              _context.next = 64;
              break;

            case 60:
              _context.prev = 60;
              _context.t9 = _context["catch"](37);
              _didIteratorError = true;
              _iteratorError = _context.t9;

            case 64:
              _context.prev = 64;
              _context.prev = 65;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 69;
                break;
              }

              _context.next = 69;
              return _awaitAsyncGenerator(_iterator.return());

            case 69:
              _context.prev = 69;

              if (!_didIteratorError) {
                _context.next = 72;
                break;
              }

              throw _iteratorError;

            case 72:
              return _context.finish(69);

            case 73:
              return _context.finish(64);

            case 74:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[37, 60, 64, 74], [65,, 69, 73]]);
    }));

    function add(_x, _x2) {
      return _add.apply(this, arguments);
    }

    return add;
  }();
});

function toCoreInterface(_ref2) {
  var name = _ref2.name,
      hash = _ref2.hash,
      size = _ref2.size,
      mode = _ref2.mode,
      mtime = _ref2.mtime,
      mtimeNsecs = _ref2.mtimeNsecs;
  var output = {
    path: name,
    cid: new CID(hash),
    size: parseInt(size)
  };

  if (mode != null) {
    output.mode = parseInt(mode, 8);
  }

  if (mtime != null) {
    output.mtime = {
      secs: mtime,
      nsecs: mtimeNsecs || 0
    };
  }

  return output;
}